import { useContext, useState } from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import { ThemeContext } from "../../App";
import './FaqPage.scss';
import faqImg from '../../assets/img/faq.png';
import FaqItem from "./FaqItem";

function FaqPage() {
    const [faqs, setFaqs] = useState([
        {
            id: "01",
            title: "What is Solporate?",
            answer: "Solporate is a NFT collection on the Solana blockchain of 2,272 cats that work at Solporate HQ. Ownership of a cat doubles as your membership to the Solporate DAO (Decentralized Autonomous Organization).",
            isOpen: false,
        },
        {
            id: "02",
            title: "What about mint?",
            answer: "Early April. Date will be updated. Mint fee will be updated close to mint.",
            isOpen: false,
        },
        {
            id: "03",
            title: "What else can I do with my Solporate Cats?",
            answer: "You can send them on business trips to earn $PURR, promote them to higher ranks, hire new interns as chief officers, and start your own Sub-Company.",
            isOpen: false,
        },
        {
            id: "04",
            title: "What can you I do with $PURR?",
            answer: "$PURR is the main currency used in Solporate. As the project develops, we are going to open Solporate Shop where you will be able to purchase real-life items using $PURR.",
            isOpen: false,
        },
        {
            id: "05",
            title: "What are these 3 regions?",
            answer: "Solporate is branched out to Solporate Valley, Las Catas, and Meow York. Each city has a different tax system and pay-out system and the place you send your cat on a business trip to will determine which Sub-DAO you join.",
            isOpen: false,
        },
        {
            id: "06",
            title: "What are Sub-DAOs?",
            answer: "Each region has a DAO that will help decide how to spend the Sub-DAO’s taxed revenue. You will also participate in the weekly DAO War for prizes. Join our discord for more information.",
            isOpen: false,
        }
    ])

   
    return <div id="faq-page" className="pt-5 pb-5 pe-3 ps-2">
        <Container fluid="xl">
            <Row>
                <h2 className="text-center ml-5 mb-5">FAQ</h2>
            </Row>
            <Row>
                <Col md={{span: 5, order: 'first'}} xs={{span: 12, order: 'last'}}>
                    <img src={faqImg} className="faq-logo" />
                </Col>
                <Col md={{span: 7, order: 'last'}} xs={{span: 12, order: 'first'}}>
                    {
                        faqs.map((faq, key)=>
                            <div key={key}>
                                <FaqItem {...faq} />
                            </div>
                        )
                    }     
                </Col>
            </Row>
        </Container>
    </div>
}

export default FaqPage;